// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3Gfyt","signatureButtonsRight":"ModalSign_signatureButtonsRight__216ir"};